import { AttributeType } from "./integration/datacatalog/datacatalog-services";
import { HeightReference } from "./presentation/routes/contract-features-3/domain";

export function heightReferenceNorwegianToDomain(heightReference: string): HeightReference {
    switch(heightReference) {
        case "Topp":
            return "TOPP";
        case "Fot":
            return "FOT";
        case "Ukjent":
            return "UKJENT";
        case "Ikke registrert":
            return "IKKE_REGISTRERT";
        default:
            return null;
    }
}

export function heightReferenceFromDomain(heightReference: HeightReference) {
    switch(heightReference) {
        case "TOPP":
            return "Topp";
        case "FOT":
            return "Fot";
        case "UKJENT":
            return "Ukjent";
        case "IKKE_REGISTRERT":
            return "Ikke registrert";
        default:
            return heightReference;
    }
}

export function getHeightReferencesNorwegian() {
    return ['Topp', 'Fot', 'Ukjent', 'Ikke registrert'];
}

export function isHeightReferenceRecommended(heightReference: HeightReference, attributeType: AttributeType) {
        if (
          !heightReference ||
          !attributeType ||
          attributeType?.heightReference === 0
        ) {
          return false;
        }

        if (
          (attributeType.heightReference === 1 && heightReference === "TOPP") ||
          (attributeType.heightReference === 2 && heightReference === "FOT") ||
          (attributeType.heightReference === 3 &&
            (heightReference === "FOT" || heightReference === "TOPP"))
        ) {
          return true;
        }

        return false;
}
